exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-slide-group__next,.v-slide-group__prev{min-width:24px!important}", ""]);

// exports
